import DisplayAd from './DisplayAd';

export default function DialogDisplayAd(props) {
  return <DisplayAd {...props} isInDialog />;
}
